import angular from 'angular';
import _ from 'lodash';

export default angular.module('message-errorcodes', []).run([
  'gettextCatalog',
  'appFactory',
  function errorCodes(gettextCatalog, appFactory) {
    appFactory.deps.config.errorCodes = _.merge(appFactory.deps.config.errorCodes, {
      message: {
        31: () => ({ title: gettextCatalog.getString('Please select Recipients.') }),
        52: () => ({ title: gettextCatalog.getString('Message content is too long.') }),
        CANNOT_BE_EMPTY: () => ({ body: gettextCatalog.getString('Message may not be empty') }),
        INVALID_SIZE: () => ({ body: gettextCatalog.getString('Message content is too long. Maximum character count is 1024') }),
        USERS_NOT_FOUND: () => ({
          title: gettextCatalog.getString('The message has not been sent'),
          body: gettextCatalog.getString('Users not found, for selected criteria.'),
        }),
      },
    });
  },
]);



// WEBPACK FOOTER //
// ./src/modules/message/config/errorcodes.conf.js